// extracted by mini-css-extract-plugin
export default {"marker":"M1HPo","main":"ktz_Q","success":"kfiPt","warning":"rw34C"};